module.exports = __webpack_public_path__ + "assets/fonts/devance.43c0dde6.svg";